"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SubCategoryFlyout = void 0;

require("core-js/modules/es6.function.name");

var _react = _interopRequireWildcard(require("react"));

var _Utils = _interopRequireDefault(require("../common/util/Utils"));

var createMarkup = function createMarkup(htmlString) {
  return {
    __html: htmlString
  };
};

var handleOnKeyDown = function handleOnKeyDown(e, props) {
  if (_Utils.default.filterKeyPress(e, [_Utils.default.keyCodeMap.space])) {
    e.preventDefault();
  } else if (e.keyCode === _Utils.default.keyCodeMap.escape) {
    props.forceCloseSubCategoryFlyout && props.forceCloseSubCategoryFlyout(_Utils.default.keyCodeMap.escape);
  } else {
    var container = typeof document !== 'undefined' ? document.querySelector('.responsive-header-flyout-content') : undefined;
    var focusable = container ? container.querySelectorAll('[href],[tabindex]:not([tabindex="-1"])') : undefined;
    var lastElement = container ? focusable[focusable.length - 1] : undefined;
    var isLastFocusableElement = e.target.isEqualNode(lastElement);

    if (e.keyCode === _Utils.default.keyCodeMap.tab && isLastFocusableElement && !e.shiftKey) {
      props.forceCloseSubCategoryFlyout && props.forceCloseSubCategoryFlyout();
    }
  }
};

var renderSubCategories = function renderSubCategories(props) {
  var activeCategory = props.activeCategory,
      brandType = props.brandType,
      flyOutContent = props.flyOutContent;
  var catName = activeCategory && activeCategory.name;
  return _react.default.createElement("div", {
    className: "responsive-header-flyout",
    onKeyDown: function onKeyDown(e) {
      return handleOnKeyDown(e, props);
    }
  }, _react.default.createElement("div", {
    className: "responsive-header-flyout-content"
  }, _react.default.createElement("span", {
    tabIndex: "-1",
    className: "cat-header"
  }, catName), _react.default.createElement("div", {
    className: "dyn-content brand-".concat(brandType),
    dangerouslySetInnerHTML: createMarkup(flyOutContent)
  })));
};

var SubCategoryFlyout = (0, _react.memo)(function (props) {
  var showFlyout = props.showFlyout,
      flyOutContent = props.flyOutContent;
  return _react.default.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      props.enableFlyout(true);
    },
    onMouseLeave: function onMouseLeave() {
      props.enableFlyout(false);
    }
  }, showFlyout && flyOutContent && renderSubCategories(props));
});
exports.SubCategoryFlyout = SubCategoryFlyout;